const AcademyIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>bebek.com Akademi</title>
      <path
        d="M5.00391 10.0006V16.0117C5.00391 16.3707 5.00391 16.5501 5.05856 16.7086C5.10689 16.8487 5.18577 16.9763 5.28949 17.0822C5.40677 17.202 5.56731 17.2823 5.88836 17.4428L11.2884 20.1428C11.5507 20.274 11.6819 20.3396 11.8195 20.3654C11.9414 20.3882 12.0664 20.3882 12.1883 20.3654C12.3259 20.3396 12.4571 20.274 12.7194 20.1428L18.1194 17.4428C18.4405 17.2823 18.601 17.202 18.7183 17.0822C18.822 16.9763 18.9009 16.8487 18.9493 16.7086C19.0039 16.5501 19.0039 16.3707 19.0039 16.0117V10.0006M2.00391 8.50055L11.6461 3.67944C11.7773 3.61385 11.8429 3.58105 11.9117 3.56814C11.9726 3.55671 12.0352 3.55671 12.0961 3.56814C12.1649 3.58105 12.2305 3.61385 12.3617 3.67944L22.0039 8.50055L12.3617 13.3217C12.2305 13.3873 12.1649 13.4201 12.0961 13.433C12.0352 13.4444 11.9726 13.4444 11.9117 13.433C11.8429 13.4201 11.7773 13.3873 11.6461 13.3217L2.00391 8.50055Z"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />{" "}
    </svg>
  );
};

export default AcademyIcon;
